export const getPreDiscountPrice = (discountedPrice: number, discountPercent: number): number => {
  if (discountPercent <= 0) {
    return discountedPrice;
  }

  return Math.round(discountedPrice / (1 - discountPercent / 100));
};

export const hasLoyaltyPricing = (loyaltyDiscount: number, loyaltyTierName?: string): boolean =>
  loyaltyDiscount > 0 && Boolean(loyaltyTierName);
